/* Content is visible before enhancement and remains so without JavaScript. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function start(scope = document) {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('editorial-enter');
        observer.unobserve(entry.target);
      }
    }, {threshold: 0.08});
    for (const element of scope.querySelectorAll('[data-editorial-reveal]')) observer.observe(element);
  }
  start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const element of event.target.querySelectorAll('[data-editorial-reveal]')) observer?.unobserve(element);
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      observer = undefined;
      for (const element of document.querySelectorAll('.editorial-enter')) element.classList.remove('editorial-enter');
    } else start();
  });
})();
